export const sidebarCssClasses = [
  'sidebar-show',
  'sidebar-sm-show',
  'sidebar-md-show',
  'sidebar-lg-show',
  'sidebar-xl-show'
];

export const asideMenuCssClasses = [
  'aside-menu-show',
  'aside-menu-sm-show',
  'aside-menu-md-show',
  'aside-menu-lg-show',
  'aside-menu-xl-show'
];

export const validBreakpoints = ['sm', 'md', 'lg', 'xl'];

export function checkBreakpoint(breakpoint, list) {
  return list.indexOf(breakpoint) > -1;
}

export const fileIconMap = {
  'application/msword': 'file-word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-word',
  'application/vnd.oasis.opendocument.text': 'file-word',
  'application/vnd.oasis.opendocument.presentation': 'file-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'file-powerpoint',
  'application/pdf': 'file-pdf',
  'application/vnd.oasis.opendocument.spreadsheet': 'file-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-excel',
  'application/vnd.ms-excel': 'file-excel',
  'application/gzip': 'file-archive',
  'application/zip': 'file-archive',
  'video/ogg': 'file-video',
  'video/mpeg': 'file-video',
  'video/webm': 'file-video',
  'video/3gpp': 'file-video',
  'image/gif': 'fa-image', // Show preview
  'image/jpeg': 'fa-image', // Show preview
  'image/png': 'fa-image', // Show preview
  'image/webp': 'fa-video', // Show preview
  file: 'file',
  image: 'image',
};

export const fileIconColor = {
  'file-word': 'icon-color-blue',
  'file-powerpoint': 'icon-color-yellow',
  'file-excel': 'icon-color-green',
  'file-pdf': 'icon-color-red',
  image: 'icon-color-pink',
};

export const mimeExtMap = {
  'text/html': 'html',
  'text/css': 'css',
  'text/xml': 'xml',
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'application/x-javascript': 'js',
  'application/atom+xml': 'atom',
  'application/rss+xml': 'rss',
  'text/mathml': 'mml',
  'text/plain': 'txt',
  'text/vnd.sun.j2me.app-descriptor': 'jad',
  'text/vnd.wap.wml': 'wml',
  'text/x-component': 'htc',
  'image/png': 'png',
  'image/tiff': 'tiff',
  'image/vnd.wap.wbmp': 'wbmp',
  'image/x-icon': 'ico',
  'image/x-jng': 'jng',
  'image/x-ms-bmp': 'bmp',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
  'application/java-archive': 'jar',
  'application/mac-binhex40': 'hqx',
  'application/msword': 'doc',
  'application/pdf': 'pdf',
  'application/postscript': 'ps',
  'application/rtf': 'rtf',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.wap.wmlc': 'wmlc',
  'application/vnd.google-earth.kml+xml': 'kml',
  'application/vnd.google-earth.kmz': 'kmz',
  'application/x-7z-compressed': '7z',
  'application/x-cocoa': 'cco',
  'application/x-java-archive-diff': 'jardiff',
  'application/x-java-jnlp-file': 'jnlp',
  'application/x-makeself': 'run',
  'application/x-perl': 'pl',
  'application/x-rar-compressed': 'rar',
  'application/x-redhat-package-manager': 'rpm',
  'application/x-sea': 'sea',
  'application/x-shockwave-flash': 'swf',
  'application/x-stuffit': 'sit',
  'application/x-tcl': 'tcl',
  'application/x-x509-ca-cert': 'crt',
  'application/x-xpinstall': 'xpi',
  'application/xhtml+xml': 'xhtml',
  'application/zip': 'zip',
  'application/octet-stream': 'bin',
  'audio/midi': 'mid',
  'audio/mpeg': 'mp3',
  'audio/ogg': 'ogg',
  'audio/x-realaudio': 'ra',
  'video/3gpp': '3gp',
  'video/mpeg': 'mpeg',
  'video/quicktime': 'mov',
  'video/x-flv': 'flv',
  'video/x-mng': 'mng',
  'video/x-ms-asf': 'asf',
  'video/x-ms-wmv': 'wmv',
  'video/x-msvideo': 'avi',
  'video/mp4': 'mp4',
};

export const extFromMime = (mime, withDot = false) => {
  if (!mime) return '';
  if (mimeExtMap[mime]) {
    return (withDot ? '.' : '') + mimeExtMap[mime];
  }
  return '';
};
